import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AssetMstApi } from '../api/assetMst.api';
import { switchMap, map } from 'rxjs/operators';

import { AssetMstData, AssetMst } from '../../../interfaces/masters/assetMst' ;
@Injectable()
export class AssetMstService extends AssetMstData {

    constructor(private api: AssetMstApi) {
      super();
    }
  
  
    list(url: string): Observable<AssetMst[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<AssetMst>{
        return this.api.getById(url);
    }
  
    create(url: string, data:AssetMst): Observable<AssetMst[]> {
      debugger;
      return this.api.add(url,data);
    }
  
    update(url: string, data:AssetMst): Observable<AssetMst> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  